// 🔧 passport_leaderboard.js
// ✅ Purpose: Public Passport Engagement Leaderboard
// ✅ Features:
// - Displays top Passport participants
// - Sorts by points earned
// - Shows completed stops
// - Highlights current user
// - Foundation for future prizes and rankings
// - Reads Engagement Engine summaries
// - Responsive Bootstrap layout

import React, { useEffect, useState } from "react";
import { httpsCallable } from "firebase/functions";
import { Link } from "react-router-dom";

import { functions } from "../../firebase";
import { useEventContext } from "../../hooks/use_event_context";
import FullPageSpinner from "../../components/FullPageSpinner";

const PassportLeaderboard = () => {
  const {
    ready,
    eventLoading,
    eventId,
    eventslug,
  } = useEventContext({
    redirectIfNotFound: true,
  });

  const [loading, setLoading] = useState(true);
  const [leaders, setLeaders] = useState([]);

  useEffect(() => {
    const loadLeaderboard = async () => {
      if (!eventId) return;

      setLoading(true);

      try {
        const getPassportLeaderboard = httpsCallable(functions, "getPassportLeaderboard");
        const result = await getPassportLeaderboard({ eventId });
        setLeaders(result.data?.leaders || []);
      } finally {
        setLoading(false);
      }
    };

    loadLeaderboard();
  }, [eventId]);

  if (!ready || eventLoading || loading) {
    return (
      <FullPageSpinner message="Loading leaderboard..." />
    );
  }

  return (
    <div className="container py-4" style={{ maxWidth: 900 }}>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2>🏆 Passport Leaderboard</h2>

          <p className="text-muted mb-0">
            See who's leading the event.
          </p>
        </div>

        <Link
          to={`/${eventslug}/passport`}
          className="btn btn-outline-secondary"
        >
          ← Passport
        </Link>
      </div>

      <div className="card shadow-sm">
        <div className="card-body p-0">
          <table className="table mb-0 align-middle">
            <thead>
              <tr>
                <th>#</th>
                <th>Participant</th>
                <th>Stops</th>
                <th>Points</th>
              </tr>
            </thead>

            <tbody>
              {leaders.map((leader, index) => (
                <tr
                  key={leader.rank}
                  className={
                    leader.isCurrentUser
                      ? "table-warning"
                      : ""
                  }
                >
                  <td>
                    <strong>
                      {leader.rank || index + 1}
                    </strong>
                  </td>

                  <td>
                    {leader.participantLabel || "Participant"}
                  </td>

                  <td>
                    {leader.completedActivityCount || 0}
                  </td>

                  <td>
                    <strong>
                      {leader.totalPoints || 0}
                    </strong>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default PassportLeaderboard;
